import { NoDataException } from '../../../utils/exceptions/nodataexistsexception';
import { SubscriptionPlanDetailsDto, SubscriptionPlanDetailsDtoImpl } from './subscriptionplandetailsdto';

export class SubscriptionPlanDetailsBuilder
{
    constructor(private subscriptionList: any)
    {
        if(subscriptionList.subscriptionPlanDetails === undefined)
        {
            throw new NoDataException("Subscription Plan Details data doesnt exists");
        }
    }

    buildAll(): SubscriptionPlanDetailsDto
    {
        return this.parseSubcriptionPlanDetailsResponse();
    }
    
    private parseSubcriptionPlanDetailsResponse(): SubscriptionPlanDetailsDto
    {
        let subscriptionDto = new SubscriptionPlanDetailsDtoImpl();
        subscriptionDto.setTitle(this.subscriptionList.subscriptionPlanDetails.title);
        console.log("Title of subscription plan:", subscriptionDto.getTitle());
        let description:string[] = [];
        subscriptionDto.setDescriptionList(description);
        // let subscriptionDto = null;
        this.subscriptionList.subscriptionPlanDetails.details.forEach((faqItem: any) =>
        {
           
            description.push(faqItem);
        });
        return subscriptionDto;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/subscriptionplandetails/subscriptionplandetailsbuilder.tsx